import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'CategoryCatalog',
  props: {
    categories: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    items() {
      return this.categories.top.map(e => ({
        label: e.label,
        url: this.buildCategoryUrl(this.locale, e.slug, e.hash)
      }));
    }

  }),
  methods: {
    tracking(label) {
      return {
        data: {
          event_category: 'Categorie',
          event_action: "Arbo_".concat(label),
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },

    catalogClick(event, eventActionLabel) {
      this.$root.$emit('generic-tracking', event, this.tracking(eventActionLabel));
    }

  }
};